import { ExtensionAttributeKeys, FreelanceRequest, MetaDataKeys } from '../../web-legacy/packages/contactUs/models/requestModels';
import { EduFormField } from './eduConstants';

type EduToFreelanceRequest = {
  [key in EduFormField]?: {
    topLevelKey?: string;
    metaDataKey?: MetaDataKeys;
    extensionAttributeKey?: ExtensionAttributeKeys;
  };
};

export const EduToFreelanceRequestMap: EduToFreelanceRequest = {
  [EduFormField.Title]: {
    topLevelKey: 'Title',
  },
  [EduFormField.Description]: {
    topLevelKey: 'UserDescription',
  },
  [EduFormField.PreferredEmail]: {
    topLevelKey: 'UserEmail',
  },
  [EduFormField.LMS]: {
    extensionAttributeKey: ExtensionAttributeKeys.EduLms,
  },
  [EduFormField.NewSdsCustomer]: {
    extensionAttributeKey: ExtensionAttributeKeys.EduNewSdsCustomer,
  },
  [EduFormField.Product]: {
    extensionAttributeKey: ExtensionAttributeKeys.EduProductName,
  },
  [EduFormField.ProductFeatureArea]: {
    extensionAttributeKey: ExtensionAttributeKeys.EduProductFeatureArea,
  },
  [EduFormField.UserImpact]: {
    extensionAttributeKey: ExtensionAttributeKeys.EduUserImpact,
  },
};

export const getValueFromFreelanceRequest = (formFieldId: EduFormField | string, freelanceRequest: FreelanceRequest) => {
  if (!freelanceRequest) {
    return null;
  }
  
  const { topLevelKey, metaDataKey, extensionAttributeKey } = EduToFreelanceRequestMap[formFieldId] || {};

  if (topLevelKey) {
    return freelanceRequest[topLevelKey];
  }
  else if (extensionAttributeKey) {
    return freelanceRequest.ExtensionAttributes?.[extensionAttributeKey];
  }
  else {
    const metaData = freelanceRequest.MetaDatas?.find(
      metaData => metaData.Key === metaDataKey
    );
    return metaData?.Value;
  }
}